const tooltips = {
  dolgozo: 'A felhasználóhoz rendelt dolgozók választhatók!',
};

export default function getTooltip(name) {
  return tooltips[name];
}
